
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's1488e73779d7682f': `۱) مرورگر خود را باز کنید`,
's182ab2d6c997515f': `برای تجربه گسترده و دسترسی آسان آن را به صفحه اصلی خود اضافه کنید.`,
's1b9047d53d9f9d22': `۱)در نوار پایین دکمه (Share) را  بزنید`,
's2d90afa5dcca2c0e': `۳) به پایین اسکرول کنید تا به "Add to Home Screen" برسید`,
's37a9e8aec5713460': `بیشتر`,
's4593f304dac8848c': `۲) روی "Add to Home screen" ضربه بزنید`,
's54cfbb14f46396d4': `۱) در مرورگر اصلی خود باز کنید`,
's6196153c4b0c1ea0': `نصب`,
's922329d6f6213590': `افزودن به (Dock)`,
'sa5ef80b4bb9b39f8': `کمتر`,
'sa7551383d1897fcc': `۲) (Add to Dock) را انتخاب کنید `,
'sba52286c21552a4e': `برای تجربه گسترده و دسترسی آسان آن را بر روی دستگاه خود نصب کنید.`,
'sc79fd7641eb9a975': ` مخفی کردن مراحل`,
'scdaf4bbff76674c8': `افزودن به (Home Screen)`,
'se740f75b95a51807': `برای تجربه گسترده و دسترسی آسان آن را به Dock خود اضافه کنید.`,
'sfea652f6580ff086': ` این سایت دارای قابلیت اپلیکیشن است. `,
    };
  